import { useState } from 'react';
import { FormattedMessage } from 'react-intl';
import SalesmanModal from '../../Modal/SalesmanModal';

const NoData = () => {
  const [isOpen, setIsOpen] = useState(false);
  return (
    <div className='no-data'>
      <div>
        <FormattedMessage id='No items to show.' />
      </div>
      <div>
        <FormattedMessage id='Do you have any questions? Contact your salesman!' />
      </div>
      <button className='button button-red block-lead-button' onClick={() => setIsOpen(true)}>
        <FormattedMessage id='Your salesman' />
      </button>
      <SalesmanModal isOpen={isOpen} onRequestClose={() => setIsOpen(false)} />
    </div>
  );
};

export default NoData;
